import axios from 'axios';
import { API_BASE_URL } from './config';

const authConfig = {
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
};

const getTickets = async () => {
    const response = await axios.get(`${API_BASE_URL}/tickets`, authConfig);
    return response.data;
};

const getTicketById = async (id) => {
    const response = await axios.get(`${API_BASE_URL}/tickets/${id}`, authConfig);
    return response.data;
};

const createTicket = async (ticketData) => {
    const response = await axios.post(`${API_BASE_URL}/tickets`, ticketData, authConfig);
    return response.data;
};

const updateTicket = async (id, ticketData) => {
    const response = await axios.put(`${API_BASE_URL}/tickets/${id}`, ticketData, authConfig);
    return response.data;
};

const deleteTicket = async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/tickets/${id}`, authConfig);
    return response.data;
};

const createTicketMessage = async (messageData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/ticketmessages`, messageData, authConfig);
        return response.data;
    } catch (error) {
        console.error("Error creating ticket message:", error);
        throw error;
    }
};

const getTicketMessages = async (ticketId) => {
    const response = await axios.get(`${API_BASE_URL}/ticketmessages/ticket/${ticketId}`, authConfig);
    return response.data;
};

const getTicketAttachments = async (ticketId) => {
    const response = await axios.get(`${API_BASE_URL}/ticketattachments/ticket/${ticketId}`, authConfig);
    return response.data;
};

const uploadAttachment = async (ticketId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('ticketId', ticketId);

    const response = await axios.post(`${API_BASE_URL}/ticketattachments`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
};

const downloadAttachment = async (attachmentId) => {
    const response = await axios.get(`${API_BASE_URL}/ticketattachments/download/${attachmentId}`, {
        withCredentials: true,
        responseType: 'blob'
    });
    return response.data;
};

export {
    getTickets,
    getTicketById,
    createTicket,
    updateTicket,
    deleteTicket,
    createTicketMessage,
    getTicketMessages,
    getTicketAttachments,
    uploadAttachment,
    downloadAttachment
};
